export default __webpack_public_path__ + "static/media/gruru.d01963ea.jpg";